import React from 'react';

import { IconPropsType } from 'designSystem/types/icons';

interface INewCoinIconProps extends IconPropsType {}

const NewCoinIcon = ({
  width = 64,
  height = 75,
  ...props
}: INewCoinIconProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 64 75"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_2349_7816)">
      <circle
        cx={33.6991}
        cy={33.6991}
        r={33.6991}
        transform="matrix(0.96753 -0.252757 0.253482 0.96734 -6.40076 16.0083)"
        fill="#FFD440"
      />
      <g filter="url(#filter0_d_2349_7816)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M38.0255 62.7523C51.6641 59.1894 59.8336 45.2848 56.2727 31.6957C52.7118 18.1065 38.7689 9.97864 25.1303 13.5416C11.4917 17.1045 3.32218 31.009 6.88308 44.5982C10.444 58.1874 24.3869 66.3152 38.0255 62.7523ZM39.4408 68.1535C56.0732 63.8084 66.0361 46.8517 61.6935 30.2795C57.351 13.7074 40.3474 3.79536 23.715 8.14041C7.08259 12.4855 -2.88029 29.4422 1.46227 46.0143C5.80483 62.5865 22.8084 72.4985 39.4408 68.1535Z"
          fill="url(#paint0_angular_2349_7816)"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M56.5902 32.2243C59.2973 45.7503 50.6948 59.0455 37.1153 62.1135C23.5154 65.1861 10.0015 56.8538 6.64189 43.4457C6.68446 43.6585 6.72984 43.8713 6.77803 44.0841C9.89061 57.8277 23.5954 66.4429 37.3885 63.3266C51.1816 60.2103 59.8398 46.5427 56.7273 32.799C56.6836 32.6064 56.6379 32.4149 56.5902 32.2243Z"
        fill="#FFF5C6"
      />
      <g filter="url(#filter1_d_2349_7816)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M44.3767 32.9381C42.6461 26.3337 35.8617 22.3855 29.2234 24.1198C22.848 25.7853 18.9246 32.0851 20.1606 38.4434L20.136 38.4498L20.3373 39.2181L24.4711 54.9936L29.8515 48.1909C31.6613 48.5652 33.5846 48.5344 35.4905 48.0365C42.1289 46.3023 46.1073 39.5425 44.3767 32.9381ZM27.836 33.2578L28.2962 33.1376L31.5783 29.6165C31.6271 29.5687 31.7053 29.5658 31.751 29.6063C31.799 29.6549 31.8017 29.7328 31.761 29.7784L28.7398 33.0217L34.8851 31.4163C35.5259 31.2489 36.1785 31.6287 36.3455 32.2661L37.5257 36.77C37.6928 37.4077 37.3101 38.0577 36.6693 38.2251L29.6284 40.0645C28.9876 40.2319 28.335 39.8523 28.1679 39.2146L26.9878 34.7108C26.8125 34.0754 27.2034 33.4231 27.836 33.2578ZM35.3132 30.6693C35.9208 30.5455 36.5552 30.8245 36.8773 31.351C36.9108 31.4121 36.8952 31.486 36.8337 31.5195C36.7723 31.553 36.6982 31.5374 36.6647 31.4764C36.3907 31.0332 35.8742 30.8018 35.3567 30.9021C35.2912 30.9192 35.227 30.8749 35.2099 30.8098C35.201 30.7423 35.2455 30.6783 35.3132 30.6693ZM35.3966 30.0955L35.1668 30.1555C35.1012 30.1726 35.0649 30.2345 35.0924 30.3059C35.1095 30.3712 35.1715 30.4072 35.2371 30.39L35.4668 30.33C36.2054 30.1371 36.9688 30.5745 37.1614 31.3093C37.1785 31.3746 37.2407 31.4108 37.3063 31.3936C37.3719 31.3765 37.4083 31.3146 37.3911 31.2493C37.1561 30.386 36.2665 29.8682 35.3966 30.0955ZM35.0291 29.6148L35.2016 29.5698C36.3519 29.2693 37.543 29.9625 37.8429 31.1068L37.8493 31.1314C37.8665 31.1968 37.8301 31.2587 37.7642 31.2759C37.6986 31.2931 37.6365 31.2569 37.6193 31.1914L37.6129 31.1669C37.3473 30.1534 36.2907 29.5387 35.272 29.8048L35.0995 29.8499C35.0338 29.867 34.9717 29.8308 34.9545 29.7654C34.9271 29.6939 34.9634 29.632 35.0291 29.6148Z"
          fill="#FFF6BD"
        />
      </g>
      <g filter="url(#filter2_d_2349_7816)">
        <path
          d="M34.896 32.7397L32.9594 33.2456L33.2738 34.4458L35.2105 33.9398L34.896 32.7397Z"
          fill="#FFF6BD"
        />
      </g>
      <g filter="url(#filter3_d_2349_7816)">
        <path
          d="M32.4565 33.3756L28.3486 34.4487L28.6635 35.6503L32.7714 34.5772L32.4565 33.3756Z"
          fill="#FFF6BD"
        />
      </g>
      <g filter="url(#filter4_d_2349_7816)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M30.2919 39.0486C30.6036 38.9671 30.7918 38.6476 30.7105 38.3374C30.6292 38.027 30.3084 37.8405 29.9966 37.9219C29.6847 38.0034 29.4967 38.3228 29.5781 38.6333C29.6593 38.9434 29.98 39.13 30.2919 39.0486Z"
          fill="#FFF6BD"
        />
      </g>
      <g filter="url(#filter5_d_2349_7816)">
        <path
          d="M32.1766 38.5686C32.4893 38.4869 32.6767 38.1684 32.5952 37.8574C32.5136 37.5462 32.194 37.3602 31.8813 37.4419C31.5686 37.5236 31.3812 37.8421 31.4627 38.1533C31.5442 38.4643 31.8639 38.6502 32.1766 38.5686Z"
          fill="#FFF6BD"
        />
      </g>
      <g filter="url(#filter6_d_2349_7816)">
        <path
          d="M35.7412 37.235C36.1064 36.6143 35.8975 35.8173 35.2747 35.4547C34.6517 35.0924 33.8507 35.3016 33.4855 35.9221C33.12 36.5429 33.3289 37.3398 33.952 37.7024C34.5748 38.065 35.3758 37.8557 35.7412 37.235Z"
          fill="#FFF6BD"
        />
      </g>
    </g>
    <defs>
      <filter
        id="filter0_d_2349_7816"
        x={-0.537514}
        y={6.13595}
        width={69.1444}
        height={68.9356}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx={2.45677} dy={2.45677} />
        <feGaussianBlur stdDeviation={1.71974} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.897119 0 0 0 0 0.625601 0 0 0 0 0.0785709 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_2349_7816"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_2349_7816"
          result="shape"
        />
      </filter>
      <filter
        id="filter1_d_2349_7816"
        x={19.9336}
        y={21.9303}
        width={28.4716}
        height={34.8445}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx={1.84257} />
        <feGaussianBlur stdDeviation={0.890577} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.901961 0 0 0 0 0.635294 0 0 0 0 0.0862745 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_2349_7816"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_2349_7816"
          result="shape"
        />
      </filter>
      <filter
        id="filter2_d_2349_7816"
        x={32.7137}
        y={32.3712}
        width={2.98825}
        height={2.44308}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx={0.122838} />
        <feGaussianBlur stdDeviation={0.184257} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.901961 0 0 0 0 0.635294 0 0 0 0 0.0862745 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_2349_7816"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_2349_7816"
          result="shape"
        />
      </filter>
      <filter
        id="filter3_d_2349_7816"
        x={28.103}
        y={33.007}
        width={5.15976}
        height={3.01193}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx={0.122838} />
        <feGaussianBlur stdDeviation={0.184257} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.901961 0 0 0 0 0.635294 0 0 0 0 0.0862745 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_2349_7816"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_2349_7816"
          result="shape"
        />
      </filter>
      <filter
        id="filter4_d_2349_7816"
        x={29.3134}
        y={37.5343}
        width={1.90744}
        height={1.90207}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx={0.122838} />
        <feGaussianBlur stdDeviation={0.184257} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.901961 0 0 0 0 0.635294 0 0 0 0 0.0862745 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_2349_7816"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_2349_7816"
          result="shape"
        />
      </filter>
      <filter
        id="filter5_d_2349_7816"
        x={31.1979}
        y={37.0543}
        width={1.90768}
        height={1.90207}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx={0.122838} />
        <feGaussianBlur stdDeviation={0.184257} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.901961 0 0 0 0 0.635294 0 0 0 0 0.0862745 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_2349_7816"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_2349_7816"
          result="shape"
        />
      </filter>
      <filter
        id="filter6_d_2349_7816"
        x={33.0599}
        y={34.9083}
        width={3.35239}
        height={3.34054}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx={0.122838} />
        <feGaussianBlur stdDeviation={0.184257} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.901961 0 0 0 0 0.635294 0 0 0 0 0.0862745 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_2349_7816"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_2349_7816"
          result="shape"
        />
      </filter>
      <radialGradient
        id="paint0_angular_2349_7816"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(31.5779 38.1469) rotate(-77.5228) scale(31.3657 31.4478)"
      >
        <stop stopColor="#FFDE47" />
        <stop offset={1} stopColor="#FFE987" />
      </radialGradient>
      <clipPath id="clip0_2349_7816">
        <rect
          width={62.2526}
          height={62.0392}
          rx={31.0196}
          transform="matrix(0.96753 -0.252757 0.253482 0.96734 -6.40076 16.0083)"
          fill="white"
        />
      </clipPath>
    </defs>
  </svg>
);

export default NewCoinIcon;
